import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { PageTitle } from '../../layout/core';
import { releaseNotes10 } from '../../components/releaseNotes/releaseNotes1-10';
import { releaseNotes20 } from '../../components/releaseNotes/releaseNotes11-20';
import { ReleaseNotes30 } from '../../components/releaseNotes/releaseNotes21-30';
import { ReleaseNotes40 } from '../../components/releaseNotes/releaseNotes31-40';
import { ReleaseNotes50 } from '../../components/releaseNotes/releaseNotes41-50';

export const ReleaseNotes = (): JSX.Element => {
    const markdown = ReleaseNotes50 + '\n' + ReleaseNotes40 + '\n' + ReleaseNotes30 + '\n' + releaseNotes20 + '\n' + releaseNotes10;
    return (
        <>
            <PageTitle breadcrumbs={[]}>Release notes</PageTitle>
            <div className="card">
                <div className="card-body">
                    <ReactMarkdown
                      children={markdown}
                      remarkPlugins={[remarkGfm]}
                    />
                </div>
            </div>
        </>
    );
};
